export default __webpack_public_path__ + "static/media/axis-fin.3d8788c4.webp";